var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77344 39.728L25.755 34.6296V13.7266L9.77344 18.7857V39.728Z",
    fill: "#B7BFCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M41.7472 39.728L25.7656 34.6296V13.7266L41.7472 18.7857V39.728Z",
    fill: "#6D7C9A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.77344 39.728L25.755 34.6296V13.7266L9.77344 18.7857V39.728Z",
    fill: "url(#paint0_linear_35866_126811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7315 39.728L25.75 34.6296V13.7266L41.7315 18.7857V39.728Z",
    fill: "url(#paint1_linear_35866_126811)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.755 44.8609L9.77344 39.7625V18.8594L25.755 23.9577V44.8609Z",
    fill: "#EDF1F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7656 44.8609L41.7472 39.7625V18.8594L25.7656 23.9577V44.8609Z",
    fill: "#DAE1ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M22.1341 41.1744L9.77344 39.7625V18.8594L25.755 23.9577L22.1341 41.1744Z",
    fill: "url(#paint2_linear_35866_126811)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.3866 37.4879L41.7472 39.7625V18.8594L25.7656 23.9577L29.3866 37.4879Z",
    fill: "url(#paint3_linear_35866_126811)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7626 13.7258L18.2486 8L2 13.5689L9.781 18.7849L25.7626 13.7258Z",
    fill: "#DAE1ED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7656 13.7258L33.2796 8L49.5283 13.5689L41.7472 18.7849L25.7656 13.7258Z",
    fill: "#DAE1ED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.781 18.8594L25.7626 23.9577L17.7909 29.1345L2 23.8008L9.781 18.8594Z",
    fill: "#EFF4FD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7472 18.8594L25.7656 23.9577L33.7374 29.1345L49.5283 23.8008L41.7472 18.8594Z",
    fill: "#EDF1F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35866_126811",
    x1: 20.71,
    y1: 15.2405,
    x2: 18.4551,
    y2: 24.4612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35866_126811",
    x1: 20.705,
    y1: 15.2405,
    x2: 18.45,
    y2: 24.4612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35866_126811",
    x1: 13.3564,
    y1: 33.1654,
    x2: 17.3199,
    y2: 22.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35866_126811",
    x1: 34.3907,
    y1: 36.1811,
    x2: 34.7036,
    y2: 22.1715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreFeature);
export default __webpack_public_path__ + "static/media/moreFeature.2e1773ec45ead9ad3ed3f5def331bd76.svg";
export { ForwardRef as ReactComponent };